<script>
import each from 'lodash/each';
import vueMixins from 'viralstyle-ui/src/vueMixins';
import VsTable from 'viralstyle-ui/src/VsTable';
import VsIconButton from 'viralstyle-ui/src/VsIconButton';
import { mapState } from 'vuex';

export default {
  components: {
    VsTable,
    VsIconButton,
  },
  mixins: [vueMixins],
  props: {
    selectable: [Boolean, String],
  },
  data: () => ({
    headings: ['Email'],
  }),
  computed: {
    ...mapState({
      processing: state => state.processing,
      paymentInfo: state => state.settings.paymentInfo,
      currentPingpongAccountId: state => state.settings.currentPingpongAccountId,
    }),
  },
  watch: {
    'paymentInfo.pingpong_accounts'() {
      this.headings = ['Email'];

      if (!this.selectable) {
        this.headings.push('Default');
      }

      if (!this.selectable && this.get(this.paymentInfo, 'pingpong_accounts.length') > 1) {
        this.headings.push('Unlink');
      }

      if (this.selectable) {
        each(this.paymentInfo.pingpong_accounts, account => {
          if (account.is_default) this.selectAccount(account.account_id);
        });
      }
    },
  },
  methods: {
    selectAccount(id) {
      this.$store.commit('updateState', { object: this.$store.state.settings, property: 'currentPingpongAccountId', value: id });
    },
    setDefault(id) {
      this.$store.dispatch('setDefaultPingpong', id);
    },
    unlink(id) {
      this.$store.dispatch('unlinkPingpong', id);
    },
    rowSelected(account) {
      return (!this.currentPingpongAccountId && account.is_default || this.currentPingpongAccountId === account.account_id) && this.selectable;
    },
  },
};
</script>

<template lang='pug'>
vs-table(
  is-large,
  :headings='headings',
  :selectable='selectable',
)
  .vs-table__row(
    v-for='account in paymentInfo.pingpong_accounts',
    :class='{ "vs-table__row--selected": rowSelected(account), "vs-table__row--action": !selectable }',
    @click='selectAccount(account.account_id)',
  )
    .vs-table__cell.vs-table__cell--break(:data-heading='headings[0]')
      h6 {{account.email}}
    .vs-table__cell(v-if='!selectable', data-heading='Default')
      vs-icon-button.vs-icon-button--margin(
        type='toggle',
        icon='check',
        :inactive='!account.is_default',
        :processing='processing',
        :disabled='processing || account.is_default',
        @click='setDefault(account.account_id)',
      )
    .vs-table__cell(v-if='!selectable && get(paymentInfo, "pingpong_accounts.length") > 1', data-heading='Unlink')
      vs-icon-button.vs-icon-button--margin(
        v-if='!account.is_default',
        type='delete' icon='close',
        :processing='processing',
        :disabled='processing',
        @click='unlink(account.account_id)',
      )
</template>

<style>
@import '~import/index';
</style>